import { all, put, takeLatest } from 'redux-saga/effects';
import { push } from 'redux-first-history';
import { Action } from 'typescript-fsa';

import * as actions from './router.actions';
import { notificationError } from '../../core/helpers/utils/notificationUtils';

export function* routerPushSaga({ payload }: Action<string>) {
  try {
    yield put(push(payload));
  } catch (err) {
    yield put(notificationError('common:errors.push_route'));
  }
}

export function* watchRouterSaga() {
  yield all([yield takeLatest(actions.pushHistoryByUrl.type, routerPushSaga)]);
}
